import axios from 'axios';
import { getCountry, getCountryCode } from './country';

const api = axios.create({ baseURL: '/api', timeout: 15000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('trd_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  cfg.headers['X-Country-Code'] = getCountryCode();
  return cfg;
});

api.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) { localStorage.clear(); window.location.href = '/login'; }
    return Promise.reject(err);
  }
);

export default api;

export const openPrivateFile = async (url) => {
  const { data } = await api.get(url, { responseType: 'blob' });
  const objectUrl = URL.createObjectURL(data);
  window.open(objectUrl, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
};

// Helpers
export const formatSalary = (min, max, currency = 'DOP', visible = true, period = 'monthly') => {
  if (!visible) return 'Salario a convenir';
  const fmt = (v) => new Intl.NumberFormat(getCountry().locale).format(v);
  const p = period === 'monthly' ? '/mes' : '/año';
  if (min && max) return `${currency} ${fmt(min)} – ${fmt(max)}${p}`;
  if (min) return `Desde ${currency} ${fmt(min)}${p}`;
  return 'Salario a convenir';
};

export const timeAgo = (dateStr) => {
  const diff = Math.floor((Date.now() - new Date(dateStr)) / 1000);
  if (diff < 3600) return `Hace ${Math.floor(diff/60)} min`;
  if (diff < 86400) return `Hace ${Math.floor(diff/3600)}h`;
  if (diff < 604800) return `Hace ${Math.floor(diff/86400)} días`;
  return new Date(dateStr).toLocaleDateString(getCountry().locale, { day:'numeric', month:'short' });
};

export const MODALITY_LABELS = { presential:'Presencial', remote:'Remoto', hybrid:'Híbrido' };
export const TYPE_LABELS = { full_time:'Tiempo completo', part_time:'Media jornada', internship:'Prácticas', freelance:'Freelance', temporary:'Temporal' };
export const EXP_LABELS = { no_experience:'Sin experiencia', junior:'Junior (0-2 años)', mid:'Medio (2-5 años)', senior:'Senior (5-8 años)', lead:'Lead (+8 años)', manager:'Manager' };
export const STATUS_LABELS = { pending:'Enviada', viewed:'Vista', shortlisted:'Preseleccionado', interview:'Entrevista', offer:'Oferta recibida', rejected:'No seleccionado', hired:'¡Contratado!', withdrawn:'Retirada' };
export const STATUS_COLORS = { pending:'gray', viewed:'blue', shortlisted:'purple', interview:'amber', offer:'green', rejected:'red', hired:'green', withdrawn:'gray' };

export const PROVINCES_DR = [
  'Azua','Bahoruco','Barahona','Dajabón','Distrito Nacional','Duarte','El Seibo',
  'Elías Piña','Espaillat','Hato Mayor','Hermanas Mirabal','Independencia',
  'La Altagracia','La Romana','La Vega','María Trinidad Sánchez','Monseñor Nouel',
  'Monte Cristi','Monte Plata','Pedernales','Peravia','Puerto Plata','Samaná',
  'San Cristóbal','San José de Ocoa','San Juan','San Pedro de Macorís',
  'Sánchez Ramírez','Santiago','Santiago Rodríguez','Santo Domingo','Valverde',
];
